module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c104645acd3a9f1102e49f91e8950216.png";